module.exports = __webpack_public_path__ + "static/img/mug.5a3f3f78.png";